// material-ui
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';

// project-imports
import Avatar from 'components/@extended/Avatar';
import {PopupTransition} from 'components/@extended/Transitions';

// assets
import {Trash} from 'iconsax-react';
import {FormattedMessage} from 'react-intl';


interface Props {
    id: string;
    title: string;
    open: boolean;
    handleClose: () => void;
    onDelete: (id: string) => void;
}

// ==============================|| CUSTOMER - DELETE ||============================== //

export default function AlertExampleElementDelete({id, title, open, handleClose, onDelete}: Props) {

    const deleteHandler = () => {
        onDelete(id)
        handleClose()
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            keepMounted
            TransitionComponent={PopupTransition}
            maxWidth="md"
            aria-labelledby="column-delete-title"
            aria-describedby="column-delete-description"
        >
            <DialogContent sx={{mt: 2, my: 1}}>
                <Stack alignItems="center" spacing={3.5}>
                    <Avatar color="error" sx={{width: 72, height: 72, fontSize: '1.75rem'}}>
                        <Trash variant="Bold"/>
                    </Avatar>
                    <Stack spacing={2}>
                        <Typography variant="h4" align="center">
                            <FormattedMessage id="Are you sure you want to delete"
                                              defaultMessage="Are you sure you want to delete"/>
                            <Typography variant="h4" component="span">
                                {' '}
                                &quot;{title}&quot;{' '}
                            </Typography>
                            ?
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{width: 1}}>
                        <Button fullWidth onClick={handleClose} color="secondary" variant="outlined">
                            <FormattedMessage id="Cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button fullWidth color="error" variant="contained" onClick={deleteHandler} autoFocus>
                            <FormattedMessage id="Delete" defaultMessage="Delete"/>
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}